"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var ClientError = /** @class */ (function (_super) {
    tslib_1.__extends(ClientError, _super);
    function ClientError(response, request) {
        var _this = this;
        var message = ClientError.extractMessage(response) + ": " + JSON.stringify({
            response: response,
            request: request,
        });
        _this = _super.call(this, message) || this;
        _this.response = response;
        _this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        //@ts-ignore
        if (typeof Error.captureStackTrace === 'function') {
            //@ts-ignore
            Error.captureStackTrace(_this, ClientError);
        }
        return _this;
    }
    ClientError.extractMessage = function (response) {
        try {
            return response.errors[0].message;
        }
        catch (e) {
            return "GraphQL Error (Code: " + response.status + ")";
        }
    };
    return ClientError;
}(Error));
exports.ClientError = ClientError;
var Batcher = /** @class */ (function () {
    function Batcher(flush) {
        this.flush = flush;
        this.buffer = [];
        this.timeout = null;
    }
    Batcher.prototype.batch = function (data) {
        var _this = this;
        if (this.timeout === null) {
            this.timeout = setTimeout(function () {
                _this.flush(_this.buffer);
                _this.buffer = [];
                _this.timeout = null;
            }, 0);
        }
        this.buffer.push(data);
    };
    return Batcher;
}());
var GraphQLClient = /** @class */ (function () {
    function GraphQLClient(url, options) {
        var _this = this;
        this.makeRequest = function (batchedData) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a, headers, others, payload, oneQuery, body, response, _results, results;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.options, headers = _a.headers, others = tslib_1.__rest(_a, ["headers"]);
                        payload = batchedData.map(function (d) { return d.data; });
                        oneQuery = payload.length === 1;
                        body = JSON.stringify(oneQuery ? payload[0] : payload);
                        return [4 /*yield*/, fetch(this.url, tslib_1.__assign({ method: 'POST', headers: Object.assign({ 'Content-Type': 'application/json' }, headers), body: body }, others))];
                    case 1:
                        response = _b.sent();
                        return [4 /*yield*/, getResult(response)];
                    case 2:
                        _results = _b.sent();
                        results = oneQuery ? [_results] : _results;
                        results.forEach(function (result, ind) {
                            var batchedD = batchedData[ind];
                            if (response.ok && !result.errors && result.data) {
                                var headers_1 = response.headers, status_1 = response.status;
                                // batchedD.resolve({ ...result, headers, status });
                                batchedD.resolve(result.data);
                            }
                            else {
                                var errorResult = typeof result === 'string' ? { error: result } : result;
                                batchedD.reject(new ClientError(tslib_1.__assign(tslib_1.__assign({}, errorResult), { status: response.status, headers: response.headers }), { query: batchedD.data.query, variables: batchedD.data.variables }));
                            }
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        this.url = url;
        this.options = options || {};
        this.batcher = new Batcher(this.makeRequest);
    }
    GraphQLClient.prototype.request = function (query, variables) {
        var resolve, reject;
        var promise = new Promise(function (res, rej) {
            resolve = res;
            reject = rej;
        });
        var data = {
            query: query,
            variables: variables ? variables : undefined,
        };
        this.batcher.batch({ data: data, resolve: resolve, reject: reject });
        return promise;
    };
    GraphQLClient.prototype.setHeaders = function (headers) {
        this.options.headers = headers;
        return this;
    };
    GraphQLClient.prototype.setHeader = function (key, value) {
        var _a;
        var headers = this.options.headers;
        if (headers) {
            headers[key] = value;
        }
        else {
            this.options.headers = (_a = {}, _a[key] = value, _a);
        }
        return this;
    };
    return GraphQLClient;
}());
exports.GraphQLClient = GraphQLClient;
function getResult(response) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var contentType;
        return tslib_1.__generator(this, function (_a) {
            contentType = response.headers.get('Content-Type');
            if (contentType && contentType.startsWith('application/json')) {
                return [2 /*return*/, response.json()];
            }
            else {
                return [2 /*return*/, response.text()];
            }
            return [2 /*return*/];
        });
    });
}
//# sourceMappingURL=request.js.map